<template>
  <v-layout column>
    <v-flex align-center justify-center>
      <v-flex pt-3 pb-4 pl-2>
        <v-layout row>
          <AreaPolygonMap ref="areaMap"></AreaPolygonMap>
        </v-layout>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";

import LocationInput from "@/components/widget/input/LocationInput.vue";
import AreaPolygonMap from "@/components/widget/AreaPolygonMap.vue";
// import { setTimeout } from "timers";

export default {
  name: "zone_map",
  components: {
    LocationInput,
    AreaPolygonMap
  },
  props: {
    loading: { type: Boolean, default: false },
    editMode: { type: Boolean, default: false }
  },
  data: function() {
    return {
      polygons: [],
      infoWindow: null
    };
  },
  mounted: function() {
    var populatePolygons = this.populatePolygons;
  },
  methods: {
    addPolygon: function(coords, color, name) {
      var polygon = new google.maps.Polygon({
        paths: coords,
        editable: false,
        draggable: false,
        strokeColor: color,
        content: name
      });

      if (this.infoWindow == null) {
        this.infoWindow = new google.maps.InfoWindow();
      }

      var vm = this;

      var showArrays = function(event) {
        vm.infoWindow.setContent(name);
        vm.infoWindow.setPosition(event.latLng);
        vm.infoWindow.open(vm.$refs.areaMap.map);
      };

      polygon.addListener("click", showArrays);

      console.log(this.$refs.areaMap.map);
      polygon.setMap(this.$refs.areaMap.map);

      console.log("Restored polygon");

      return polygon;
    },
    populatePolygons: function(zones) {
      console.log("Populating Polygons");

      if (this.polygons != null) {
        for (var i = 0; i < this.polygons.length; i++) {
          this.polygons[i].setMap(null);
        }
        this.polygons = [];
      }

      var bounds = new google.maps.LatLngBounds();

      for (var j = 0; j < zones.length; j++) {
        var polygonCoords = [];
        var polygonJSON = zones[j].area;

        for (var i = 0; i < polygonJSON.length; i++) {
          polygonCoords.push({
            lat: polygonJSON[i][0],
            lng: polygonJSON[i][1]
          });

          bounds.extend({
            lat: polygonJSON[i][0],
            lng: polygonJSON[i][1]
          });
        }

        this.polygons.push(
          this.addPolygon(polygonCoords, "#ebebeb", zones[j].name)
        );
      }

      this.$refs.areaMap.map.fitBounds(bounds);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
